import { render, staticRenderFns } from "./CenterModeSlider.vue?vue&type=template&id=627bccfc&"
import script from "./CenterModeSlider.vue?vue&type=script&lang=js&"
export * from "./CenterModeSlider.vue?vue&type=script&lang=js&"
import style0 from "./CenterModeSlider.vue?vue&type=style&index=0&id=627bccfc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports